import Crypto from 'crypto';
const IV = "sFpQIWhcYpDYbtDl";

export const hash = (string) => {
  const hash = Crypto.createHash("sha1").update(string).digest("hex");
  return hash;
};

export const createKey = (string) => {
  const hash = Crypto.createHash("sha256").update(string).digest('base64').substr(0, 32);
  return hash;
};

export const encrypt = (string, key) => {
	const cipher = Crypto.createCipheriv('aes-256-ctr', key, IV);
	let crypted = cipher.update(string, 'utf8', 'hex');
	crypted += cipher.final('hex');
	return crypted;
};

export const decrypt = (string, key) => {
	if(!key || !string){
		return '';
	};
	const decipher = Crypto.createDecipheriv('aes-256-ctr', key, IV);
	let decrypted = decipher.update(string, 'hex', 'utf8');
	decrypted += decipher.final('utf8');
	return decrypted;
};